import type { Money } from '../api/ledger'

/** Format minor units with the currency's own decimals (EUR 2, JPY 0). `signed` adds +/− (not for zero). */
export function formatMoney(m: Money, locale: string, signed = false): string {
  const f = new Intl.NumberFormat(locale, { style: 'currency', currency: m.currency, signDisplay: signed ? 'exceptZero' : 'auto' })
  return f.format(m.amount_minor / 10 ** (f.resolvedOptions().maximumFractionDigits ?? 2))
}

/** Client-side IBAN check (ISO 13616 mod-97) for an input hint; the server validates again. */
export function isValidIban(raw: string): boolean {
  const s = raw.replace(/\s+/g, '').toUpperCase()
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(s)) return false
  const digits = (s.slice(4) + s.slice(0, 4)).replace(/[A-Z]/g, (c) => String(c.charCodeAt(0) - 55))
  let rem = 0
  for (const d of digits) rem = (rem * 10 + Number(d)) % 97
  return rem === 1
}

/** YYYY-MM-DD of `days` ago (UTC), for period defaults. */
export const isoDaysAgo = (days: number) => new Date(Date.now() - days * 864e5).toISOString().slice(0, 10)
